import { Link } from 'react-router-dom';
import { articles } from '@/mocks/anime';

export default function NewsSection() {
  const [feature, ...rest] = articles;
  return (
    <section className="bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
          <div>
            <p className="text-sm font-medium text-secondary-600">NEWS &amp; GUIDE</p>
            <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">新番资讯与补番指南</h2>
          </div>
          <Link to="/articles" className="flex items-center gap-1 text-sm text-foreground-600 hover:text-secondary-600 transition-colors whitespace-nowrap">
            全部资讯 <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-3">
          <Link to={`/article/${feature.id}`} className="group overflow-hidden rounded-lg bg-background-50 lg:col-span-1">
            <div className="relative aspect-[16/10] w-full overflow-hidden">
              <img
                src={feature.image}
                alt={feature.title}
                title={`${feature.title} - 动漫网`}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                头条
              </span>
            </div>
            <div className="p-5">
              <h3 className="font-heading text-lg leading-snug text-foreground-950 group-hover:text-primary-600 transition-colors">
                {feature.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm text-foreground-500">{feature.summary}</p>
              <p className="mt-3 flex items-center gap-2 text-xs text-foreground-400">
                <i className="ri-calendar-line" aria-hidden="true" />{feature.date}
                <span>·</span>
                <i className="ri-eye-line" aria-hidden="true" />{feature.views} 阅读
              </p>
            </div>
          </Link>

          <div className="grid grid-cols-1 gap-4 lg:col-span-2">
            {rest.slice(0, 3).map((n) => (
              <Link
                key={n.id}
                to={`/article/${n.id}`}
                className="group flex gap-4 rounded-lg bg-background-50 p-3 transition-colors hover:bg-background-100"
              >
                <div className="h-24 w-36 shrink-0 overflow-hidden rounded-md">
                  <img
                    src={n.image}
                    alt={n.title}
                    title={`${n.title} - 动漫网`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="font-heading text-base leading-snug text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {n.title}
                  </h3>
                  <p className="mt-1.5 line-clamp-2 text-sm text-foreground-500">{n.summary}</p>
                  <p className="mt-2 flex items-center gap-2 text-xs text-foreground-400">
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">{n.categoryName}</span>
                    <i className="ri-eye-line" aria-hidden="true" />{n.views}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}